export const environment = {
  baseUrl: 'https://retention.dev-usc1.aodocs.app',
  apiUrl: '/_ah/api/',
  finraApiUrl: 'https://retention.dev-usc1.aodocs.app',
  aodocsUrl: 'https://aodocs-staging.altirnao.com/',
  clientId: '390998923355-2rdve4m9ikcnao3da9h4p042d4rrq0mb',
  gcsAPI: 'https://storage.googleapis.com/upload/storage/v1/b/{BUCKET}/o',
  ossApi: 'https://aodocs-object-storage.appspot.com/api/storage',
  version: '4.0.0',
  production: false,
  microsoftAuthEnabled: true,
  googleAuthEnabled: true,
  firebase: {
    apiKey: 'AIzaSyBWo5_zgbMgKf5nbYrn749NgvNGkBri23k',
    authDomain: 'ao-docs-staging.firebaseapp.com',
    databaseURL: 'https://ao-docs-staging.firebaseio.com',
    projectId: 'ao-docs-staging',
    storageBucket: 'ao-docs-staging.appspot.com',
    messagingSenderId: '563231141203',
    appId: '1:563231141203:web:69fd2c6b041e95f93845a6',
    measurementId: 'G-0RJZXTDXBR',
  }
};

